"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = getCommonI18nextConfiguration;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/* eslint-disable filenames/match-exported */

function getCommonI18nextConfiguration() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      customLoader = _ref.customLoader,
      _ref$defaultNamespace = _ref.defaultNamespace,
      defaultNamespace = _ref$defaultNamespace === undefined ? "general" : _ref$defaultNamespace,
      _ref$detectionCookieN = _ref.detectionCookieName,
      detectionCookieName = _ref$detectionCookieN === undefined ? "lang" : _ref$detectionCookieN,
      detectionOrder = _ref.detectionOrder,
      _ref$detectionQuerySt = _ref.detectionQueryStringVariable,
      detectionQueryStringVariable = _ref$detectionQuerySt === undefined ? "lang" : _ref$detectionQuerySt,
      _ref$fallbackLanguage = _ref.fallbackLanguage,
      fallbackLanguage = _ref$fallbackLanguage === undefined ? "en" : _ref$fallbackLanguage,
      fallbackNamespace = _ref.fallbackNamespace,
      _ref$instantInitializ = _ref.instantInitialization,
      instantInitialization = _ref$instantInitializ === undefined ? true : _ref$instantInitializ,
      interpolationPrefix = _ref.interpolationPrefix,
      interpolationSuffix = _ref.interpolationSuffix,
      _ref$interpolationWra = _ref.interpolationWrapper,
      interpolationWrapper = _ref$interpolationWra === undefined ? "__" : _ref$interpolationWra,
      language = _ref.language,
      _ref$languageWhitelis = _ref.languageWhitelist,
      languageWhitelist = _ref$languageWhitelis === undefined ? ["en", "fr"] : _ref$languageWhitelis,
      _ref$namespaceList = _ref.namespaceList,
      namespaceList = _ref$namespaceList === undefined ? [] : _ref$namespaceList,
      _ref$namespaceSeparat = _ref.namespaceSeparator,
      namespaceSeparator = _ref$namespaceSeparat === undefined ? "::" : _ref$namespaceSeparat,
      _ref$nonExplicitWhite = _ref.nonExplicitWhitelist,
      nonExplicitWhitelist = _ref$nonExplicitWhite === undefined ? false : _ref$nonExplicitWhite,
      _ref$returnObjects = _ref.returnObjects,
      returnObjects = _ref$returnObjects === undefined ? true : _ref$returnObjects,
      i18nextOptions = (0, _objectWithoutProperties3.default)(_ref, ["customLoader", "defaultNamespace", "detectionCookieName", "detectionOrder", "detectionQueryStringVariable", "fallbackLanguage", "fallbackNamespace", "instantInitialization", "interpolationPrefix", "interpolationSuffix", "interpolationWrapper", "language", "languageWhitelist", "namespaceList", "namespaceSeparator", "nonExplicitWhitelist", "returnObjects"]);

  var configuration = (0, _extends3.default)({
    customLoad: customLoader,
    defaultNS: defaultNamespace,
    detection: {
      lookupCookie: detectionCookieName,
      lookupQuerystring: detectionQueryStringVariable,
      order: detectionOrder
    },
    fallbackLng: fallbackLanguage,
    fallbackNS: fallbackNamespace,
    initImmediate: instantInitialization,
    interpolation: {
      prefix: interpolationPrefix || interpolationWrapper,
      suffix: interpolationSuffix || interpolationWrapper
    },
    lng: language,
    nonExplicitWhitelist: nonExplicitWhitelist,
    ns: namespaceList,
    nsSeparator: namespaceSeparator,
    returnObjects: returnObjects,
    whitelist: languageWhitelist
  }, i18nextOptions);

  return configuration;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/localization/config/i18next/common.js
// module id = 881
// module chunks = 6